/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { UserService } from './user.service';
import { AuthService } from './auth.service';

declare let drift: any;

@Injectable()
export class DriftService {

  constructor(private userService: UserService,
    private authService: AuthService,
    private http: HttpClient) { }

  identify() {
    if (this.authService.isLoggedIn) {
      this.userService.getProfile().subscribe(
        (result: any) => {
          if (this.authService.currentRole.mask <= 16) {
            drift.identify(result.email_address, { email: result.email_address, account: result.account });
          }
        },
        err => {

        }
      );
    }
  }

  page(name: string) {
    if (this.authService.currentRole.mask <= 16) {
      drift.page(name);
    }
  }

  track(event: string, attributes: any = {}) {
    if (this.authService.currentRole.mask <= 16) {
      drift.track(event, attributes);
    }
  }

  //// Integration Endpoints

  private listCache: any[] = [];
  private fieldCache: any[] = [];

  grantAccess(code): Observable<any> {
    return this.http
      .post(
        `/api/v1/drift/grant`,
        { code: code }
      );
  }


  getFields(): Observable<any> {
    if (this.fieldCache.length > 0) {
      return Observable.of(this.fieldCache);
    }

    return this.http
      .get(
        `/api/v1/drift/fields`
      )
      .map((response: any) => {
        this.fieldCache = response || [];
        return response;
      });
  }

  getLists(): Observable<any> {
    if (this.listCache.length > 0) {
      return Observable.of(this.listCache);
    }

    return this.http
      .get(
        `/api/v1/drift/lists`
      )
      .map((response: any) => {
        this.listCache = response || [];
        return response;
      });
  }

  clearListCache() {
    this.listCache = [];
  }

  clearFieldCache() {
    this.fieldCache = [];
  }

  clearAll() {
    this.listCache = [];
    this.fieldCache = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/drift.service.ts